/**
 * HUB-E — Carte alerte stock (rupture / faible).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import MagasinBadge from '../MagasinBadge';

export default function ActiviteStockAlertCard({ article, variant = 'faible', testIdPrefix = 'activite-stock' }) {
  const isRupture = variant === 'rupture';

  return (
    <article
      className="rounded-xl border p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
      style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
      data-testid={`${testIdPrefix}-alert-${article.reference}`}
    >
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-2 mb-1">
          <MagasinBadge code={article.magasin_id || 'M1'} size="sm" />
          <span className={isRupture ? 'rm-badge rm-badge--danger' : 'rm-badge rm-badge--muted'}>
            {isRupture ? 'Rupture' : 'Stock faible'}
          </span>
        </div>
        <p className="font-semibold text-[var(--rm-white)] truncate">{article.designation}</p>
        <p className="text-xs font-mono text-[var(--rm-gray-500)]">{article.reference}</p>
        <p className="text-sm mt-1">
          <span className="text-[var(--rm-gray-500)]">Qté </span>
          <span className={`font-bold ${isRupture ? 'text-[var(--rm-red-light)]' : 'text-[var(--rm-gray-200)]'}`}>
            {article.quantite ?? 0}
          </span>
          <span className="text-[var(--rm-gray-500)] ml-3">Seuil {article.seuil_alerte ?? 3}</span>
        </p>
      </div>
      {article.id && (
        <Link
          to={`/stock/modifier/${article.id}`}
          className="btn-secondary px-4 py-2.5 min-h-[44px] text-sm inline-flex items-center gap-2 shrink-0"
          data-testid={`${testIdPrefix}-alert-link-${article.id}`}
        >
          Fiche article
          <ExternalLink className="w-4 h-4" />
        </Link>
      )}
    </article>
  );
}
